import type { DataTableHeader } from 'best-modules/components'

// best-modules `DataTableHeader` не містить `disabled`, але рантайм-таблиця його
// читає для колонки дій. Розширюємо тип, не змінюючи поведінку.
type AppDataTableHeader = DataTableHeader & { disabled?: boolean }

const taskHeaders: AppDataTableHeader[] = [
  {
    key: 'status',
    title: 'Статус',
    minWidth: '150px',
  },
  {
    key: 'topic',
    title: 'Тема',
    minWidth: '230px',
  },
  {
    key: 'executor',
    title: 'Виконавець',
    minWidth: '150px',
  },
  {
    key: 'author',
    title: 'Автор',
    minWidth: '150px',
  },
  {
    key: 'deadline',
    title: 'Термін виконання',
    minWidth: '150px',
  },
  {
    key: 'completedDate',
    title: 'Дата завершення',
    minWidth: '170px',
  },
  {
    key: 'contractor',
    title: 'Контрагент',
  },
  {
    key: 'connect',
    title: "Зв'язок",
  },
  {
    key: 'actions',
    title: 'Дії',
    align: 'end',
    disabled: true,
  },
]

const correspondenceListHeaders: DataTableHeader[] = [
  {
    key: 'registrationDate',
    title: 'Дата реєстрації',
    minWidth: '160px',
    align: 'start',
  },
  {
    key: 'registrationNumber',
    title: 'Номер',
    align: 'start',
  },
  {
    key: 'type.name',
    title: 'Тип',
  },
  {
    key: 'documentType',
    title: 'Тип документа',
    minWidth: '180px',
  },
  {
    key: 'contractor',
    title: 'Кореспондент',
  },
  {
    key: 'subject',
    title: 'Тема',
  },
  {
    key: 'documents',
    title: 'Документи',
  },
  {
    key: 'responsible',
    title: 'Відповідальний',
  },
  {
    key: 'actions',
    title: 'Дії',
  },
]

const correspondenceTaskHeaders: DataTableHeader[] = [
  {
    key: 'status.name',
    title: 'Статус',
    align: 'start',
  },
  { key: 'type.name', title: 'Тип', align: 'start' },
  { key: 'topic', title: 'Назва', align: 'start' },
  { key: 'responsible', title: 'Відповідальний', align: 'start' },
  { key: 'deadline', title: 'Термін виконання', align: 'start' },
  { key: 'actions', title: 'Дії', align: 'end' },
]

const historyHeaders: DataTableHeader[] = [
  {
    title: 'Користувач',
    align: 'start',
    key: 'userName',
    sortable: false,
  },
  {
    title: 'Дата',
    key: 'date',
    sortable: false,
    align: 'start',
    minWidth: '135px',
  },
  { title: 'Поле', key: 'field', sortable: false, align: 'start' },
  {
    title: 'Зміни',
    key: 'changedValue',
    sortable: false,
    align: 'start',
  },
]

const orderTaskHeaders: DataTableHeader[] = [
  {
    title: 'Статус',
    align: 'start',
    key: 'status',
    sortable: false,
  },
  {
    title: 'Назва',
    align: 'start',
    key: 'topic',
    sortable: false,
  },
  {
    title: 'Автор',
    align: 'start',
    key: 'author',
    sortable: false,
  },
  {
    title: 'Виконавець',
    align: 'start',
    key: 'executor',
    sortable: false,
  },
]
const protocolTaskHeaders: DataTableHeader[] = [
  {
    title: 'Статус',
    align: 'start',
    key: 'status',
    sortable: false,
  },
  {
    title: 'Назва',
    align: 'start',
    key: 'topic',
    sortable: false,
  },
  {
    title: 'Автор',
    align: 'start',
    key: 'author',
    sortable: false,
  },
  {
    title: 'Виконавець',
    align: 'start',
    key: 'executor',
    sortable: false,
  },
]

const contractorFounderListHeaders: DataTableHeader[] = [
  { title: 'ПІБ', key: 'name', sortable: false },
  { title: 'IНН/ЄДРПОУ', key: 'code', sortable: false, align: 'start' },
  {
    title: 'Частка статутного капіталу - грн',
    key: 'amount',
    align: 'center',
    sortable: false,
  },
  {
    title: 'Частка статутного капіталу - %',
    key: 'percent',
    align: 'center',
    sortable: false,
  },
  { title: 'Адреса', key: 'location', sortable: false, align: 'start' },
]

const contractorBeneficialListHeaders: DataTableHeader[] = [
  { title: 'ПIБ', key: 'contact', sortable: false },
  { title: 'IНН/ЄДРПОУ', key: 'inn', sortable: false, align: 'start' },
  {
    title: 'Громадянство',
    key: 'nationality',
    sortable: false,
    align: 'center',
  },
  {
    title: 'Дата народження',
    key: 'birthday',
    sortable: false,
    align: 'center',
  },
  {
    title: 'Адреса',
    key: 'address',
    sortable: false,
    align: 'start',
  },
]

const contractorQuedHeaders: DataTableHeader[] = [
  { title: 'Назва діяльності', key: 'name', sortable: false },
  { title: 'Код діяльності', key: 'code', sortable: false },
]

const contractorCollegialListHeaders: DataTableHeader[] = [
  { title: 'ПIБ', key: 'contact', sortable: false },
  { title: 'IНН/ЄДРПОУ', key: 'inn', sortable: false, align: 'start' },
  {
    title: 'Громадянство',
    key: 'nationality.name',
    sortable: false,
    align: 'center',
  },
  {
    title: 'Дата народження',
    key: 'birthday',
    sortable: false,
    align: 'center',
  },
  {
    title: 'Адреса',
    key: 'address',
    sortable: false,
    align: 'start',
  },
]

const contractorDirectorListHeaders: DataTableHeader[] = [
  { title: 'ПIБ', key: 'contact', sortable: false },
  { title: 'IНН/ЄДРПОУ', key: 'inn', sortable: false, align: 'start' },
  {
    title: 'Громадянство',
    key: 'nationality.name',
    sortable: false,
    align: 'center',
  },
  {
    title: 'Дата народження',
    key: 'birthday',
    sortable: false,
    align: 'center',
  },
  {
    title: 'Адреса',
    key: 'address',
    sortable: false,
    align: 'start',
  },
]

const companyStructureHeaders: DataTableHeader[] = [
  { key: 'name', title: 'Назва' },
  { key: 'actions', title: 'Дії', width: '68px', sortable: false },
]

const familiarizationListHeaders: DataTableHeader[] = [
  {
    title: 'Користувач',
    align: 'start',
    key: 'user',
    width: '300px',
    sortable: false,
  },
  {
    title: 'Ознайомлений',
    key: 'isAccept',
    sortable: false,
    width: '220px',
    align: 'start',
  },
  {
    title: 'Дата',
    key: 'dateAccept',
    sortable: false,
    align: 'start',
  },
]

const documentAgreementUsersHeaders: DataTableHeader[] = [
  {
    key: 'user',
    title: 'ПІБ',
  },
  {
    key: 'agreementDate',
    title: 'Дата',
  },
  {
    key: 'isAgreed',
    title: 'Статус погодження',
  },
]

const familiarizationUsersHeaders: DataTableHeader[] = [
  {
    key: 'user',
    title: 'ПІБ',
  },
  {
    key: 'isFamiliarization',
    title: 'Ознайомлений',
  },
  {
    key: 'familiarizationDate',
    title: 'Дата ознайомлення',
  },
]

const documentAgreementLogsHeaders: DataTableHeader[] = [
  {
    key: 'user',
    title: 'ПІБ',
  },
  {
    key: 'created_at',
    title: 'Дата',
  },
  {
    key: 'status',
    title: 'Статус',
  },
]

const documentListHeaders: DataTableHeader[] = [
  {
    key: 'created_at',
    title: 'Дата',
    align: 'start',
    sortable: false,
  },
  {
    key: 'name',
    title: 'Назва',
    align: 'start',
    sortable: false,
  },
  {
    key: 'status',
    title: 'Статус',
    align: 'start',
    sortable: false,
  },
  {
    key: 'number',
    title: 'Номер',
    align: 'start',
    sortable: false,
  },
  {
    key: 'type',
    title: 'Тип',
    align: 'start',
    sortable: false,
    minWidth: '140px',
  },
  {
    key: 'author',
    title: 'Автор',
    sortable: false,
  },
  {
    key: 'contractors',
    title: 'Контрагенти',
    align: 'center',
    sortable: false,
  },
]

const incidentListHeaders: AppDataTableHeader[] = [
  {
    key: 'number',
    title: '№ інциденту',
    align: 'start',
    sortable: false,
    disabled: true,
    minWidth: '155px',
  },
  {
    key: 'created_at',
    title: 'Створено',
    align: 'start',
    sortable: false,
  },
  {
    key: 'occurredDate',
    title: 'Дата виникнення',
    align: 'start',
    sortable: false,
  },
  {
    key: 'type',
    title: 'Тип',
    align: 'start',
    sortable: false,
  },
  {
    key: 'name',
    title: 'Заголовок',
    align: 'start',
    sortable: false,
  },
  {
    key: 'responsible',
    title: 'Відповідальний',
    align: 'start',
    sortable: false,
  },
  {
    key: 'priority',
    title: 'Пріоритет',
    align: 'start',
    sortable: false,
  },
  {
    key: 'status',
    title: 'Статус',
    align: 'start',
    sortable: false,
  },
]

const incidentSettlementListHeaders: AppDataTableHeader[] = [
  {
    key: 'incident',
    title: 'Інцидент',
    align: 'start',
    sortable: false,
    disabled: true,
    minWidth: '150px',
  },
  {
    key: 'task',
    title: 'Завдання',
    align: 'start',
    sortable: false,
    minWidth: '420px',
  },
  {
    key: 'taskStatus',
    title: 'Статус завдання',
    align: 'start',
    sortable: false,
    minWidth: '150px',
  },
  {
    key: 'author',
    title: 'Автор',
    align: 'start',
    sortable: false,
    minWidth: '180px',
  },
  {
    key: 'created_at',
    title: 'Дата створення',
    align: 'start',
    sortable: false,
    minWidth: '140px',
  },
  {
    key: 'executor',
    title: 'Виконавець',
    align: 'start',
    sortable: false,
    minWidth: '180px',
  },
  {
    key: 'deadline',
    title: 'Термін',
    align: 'start',
    sortable: false,
    minWidth: '140px',
  },
]

const auditRecommendationTaskListHeaders: AppDataTableHeader[] = [
  {
    key: 'audit',
    title: 'Аудит',
    align: 'start',
    sortable: false,
    disabled: true,
    minWidth: '150px',
  },
  {
    key: 'task',
    title: 'Завдання',
    align: 'start',
    sortable: false,
    minWidth: '420px',
  },
  {
    key: 'taskStatus',
    title: 'Статус завдання',
    align: 'start',
    sortable: false,
    minWidth: '150px',
  },
  {
    key: 'author',
    title: 'Автор',
    align: 'start',
    sortable: false,
    minWidth: '180px',
  },
  {
    key: 'created_at',
    title: 'Дата створення',
    align: 'start',
    sortable: false,
    minWidth: '140px',
  },
  {
    key: 'executor',
    title: 'Виконавець',
    align: 'start',
    sortable: false,
    minWidth: '180px',
  },
  {
    key: 'deadline',
    title: 'Термін',
    align: 'start',
    sortable: false,
    minWidth: '140px',
  },
]

const incidentIssueTaskHeaders: DataTableHeader[] = [
  { title: 'Статус завдання', key: 'status', sortable: false },
  { title: 'Завдання', key: 'task', sortable: false },
  { title: 'Виконавець', key: 'executor', sortable: false },
  { title: 'Дедлайн', key: 'deadline', sortable: false },
]

const orderListHeaders: DataTableHeader[] = [
  {
    title: 'Номер',
    align: 'start',
    key: 'number',
    sortable: false,
    maxWidth: '100px',
  },
  { title: 'Статус', key: 'isActive', sortable: false, align: 'start' },
  { title: 'Тема', key: 'name', sortable: false, align: 'start' },
  {
    title: 'Хто підготовив',
    key: 'issuedUser',
    sortable: false,
    align: 'start',
  },
]
const protocolListHeaders: DataTableHeader[] = [
  {
    title: 'Номер',
    align: 'start',
    key: 'number',
    sortable: false,
    maxWidth: '100px',
  },
  { title: 'Статус', key: 'isActive', sortable: false, align: 'start' },
  { title: 'Тема', key: 'name', sortable: false, align: 'start' },
  {
    title: 'Хто підготовив',
    key: 'issuedUser',
    sortable: false,
    align: 'start',
  },
]

const departmentListHeaders: DataTableHeader[] = [
  { key: 'name', title: 'Назва' },
  {
    key: 'actions',
    title: 'Дії',
    align: 'end',
    width: '68px',
    sortable: false,
  },
]

const departmentUserListHeaders: DataTableHeader[] = [
  {
    title: 'ПIБ',
    key: 'name',
    align: 'start',
  },
  {
    title: 'Статус',
    key: 'isActive',
  },
  {
    title: 'Посада',
    key: 'user.post',
    width: '190px',
  },
  {
    key: 'actions',
    title: 'Дії',
    align: 'end',
    width: '68px',
    sortable: false,
  },
]

const acknowledgmentAssignmentListHeaders: DataTableHeader[] = [
  {
    title: 'ПІБ',
    align: 'start',
    key: 'fullName',
    sortable: false,
  },
  { title: 'Посада', key: 'description', sortable: false, align: 'start' },
  { title: 'Дії', key: 'actions', sortable: false, align: 'end' },
]

const auditListHeaders: AppDataTableHeader[] = [
  {
    key: 'status',
    title: 'Статус',
    sortable: false,
  },
  {
    key: 'name',
    title: 'Назва аудиту',
    sortable: false,
  },
  {
    key: 'year',
    title: 'Рік',
    sortable: false,
  },
  {
    key: 'type.name',
    title: 'Вид',
    sortable: false,
  },
  {
    key: 'author',
    title: 'Автор',
    sortable: false,
  },
  {
    key: 'actions',
    title: 'Дії',
    sortable: false,
    align: 'end',
    disabled: true,
  },
]

const auditRecommendationListHeaders: DataTableHeader[] = [
  {
    key: 'task',
    title: 'Завдання',
    sortable: false,
  },
  {
    key: 'taskStatus',
    title: 'Статус завдання',
    sortable: false,
  },
  {
    key: 'executor',
    title: 'Виконавець',
    sortable: false,
  },
  {
    key: 'recommendationStatus',
    title: 'Статус рекомендації',
    sortable: false,
  },
  {
    key: 'actions',
    title: 'Дії',
    sortable: false,
    align: 'end',
  },
]

const contractorListHeaders: DataTableHeader[] = [
  { key: 'name', title: 'Назва', align: 'start' },
  {
    key: 'type',
    title: 'Тип',
    align: 'start',
  },
  { key: 'code', title: 'ЄДРПОУ/ІНН', align: 'start' },
]

const templateRoutingListHeaders: DataTableHeader[] = [
  {
    key: 'name',
    title: 'Назва маршруту',
  },
  {
    key: 'documentType',
    title: 'Тип документа',
  },
  {
    key: 'steps',
    title: 'Етапи',
  },
  {
    key: 'employees',
    title: 'Учасники',
  },
  {
    key: 'status',
    title: 'Статус',
  },
  {
    key: 'actions',
    title: 'Дії',
    sortable: false,
    align: 'end',
  },
]

const planAuditListHeaders: DataTableHeader[] = [
  {
    key: 'name',
    title: 'Назва',
  },
  {
    key: 'date',
    title: 'Дата аудиту',
  },
  {
    key: 'status',
    title: 'Статус аудиту',
  },
  {
    key: 'author',
    title: 'Автор',
  },
  {
    key: 'delete',
    title: '',
    align: 'end',
    sortable: false,
  },
]

const internalDepartmentListHeaders: DataTableHeader[] = [
  { title: 'Код', key: 'internalCode', width: '50px', sortable: false },
  { title: 'Назва', key: 'name', sortable: false },
  {
    title: 'Тип підрозділу',
    key: 'departmentType.name',
    sortable: false,
    align: 'center',
  },
  { title: 'Статус', key: 'status', width: '120px', sortable: false },
  {
    title: '',
    key: 'actions',
    width: '60px',
    sortable: false,
    align: 'end',
  },
]

const roleListHeaders: DataTableHeader[] = [
  { title: 'Назва', key: 'name', sortable: false },
  { title: 'Опис', key: 'description', sortable: false },
  { title: 'Область даних', key: 'data_scope', sortable: false },
  { title: 'Кількість прав', key: 'permissions_count', sortable: false },
  { title: 'Дії', key: 'actions', sortable: false },
]

const fieldDefinitionListHeaders: DataTableHeader[] = [
  { key: 'name', title: 'Назва' },
  { key: 'fieldType', title: 'Тип', sortable: false },
  { key: 'usages', title: 'Використання', sortable: false },
  { key: 'actions', title: 'Дії', sortable: false },
]

const docTypeFieldListHeaders: DataTableHeader[] = [
  { key: 'sortOrder', title: '#', sortable: false, width: '50px' },
  { key: 'name', title: 'Назва' },
  { key: 'fieldType', title: 'Тип поля', sortable: false },
  { key: 'isRequired', title: "Обов'язкове", sortable: false },
  { key: 'readonly', title: 'Лише читання', sortable: false },
  { key: 'isHidden', title: 'Приховане', sortable: false },
  { key: 'entitySource', title: "Прив'язана сутність", sortable: false },
  { key: 'actions', title: 'Дії', sortable: false, align: 'end' },
]

const docTypeDefinitionListHeaders: DataTableHeader[] = [
  { key: 'code', title: 'Код' },
  { key: 'name', title: 'Назва' },
  { key: 'docTypeClass', title: 'Клас документа', sortable: false },
  {
    key: 'registrationMarkType',
    title: 'Реєстраційна відмітка',
    sortable: false,
  },
  { key: 'isActive', title: 'Статус', sortable: false },
  { key: 'actions', title: 'Дії', sortable: false, align: 'end' },
]

const docTypeDocumentListHeaders: DataTableHeader[] = [
  { key: 'status', title: 'Стан', sortable: false },
  { key: 'registrationNumber', title: 'Реєстраційний номер', sortable: false },
  { key: 'registrationDate', title: 'Дата реєстрації', sortable: false },
  {
    key: 'definition',
    title: 'Тип документа',
    sortable: false,
    minWidth: '190px',
    maxWidth: '190px',
  },
  {
    key: 'docTypeClass',
    title: 'Клас документа',
    sortable: false,
    minWidth: '190px',
    maxWidth: '190px',
  },
  {
    key: 'department',
    title: 'Підрозділ',
    sortable: false,
    minWidth: '190px',
    maxWidth: '190px',
  },
  {
    key: 'executor',
    title: 'Виконавець',
    sortable: false,
    minWidth: '190px',
    maxWidth: '190px',
  },
  {
    key: 'journal',
    title: 'Журнал реєстрації',
    sortable: false,
    minWidth: '190px',
    maxWidth: '190px',
  },
  { key: 'created_at', title: 'Дата створення', sortable: false },
  {
    key: 'actions',
    title: 'Дії',
    sortable: false,
    align: 'end',
  },
]

const orgDirectoryHeaders: DataTableHeader[] = [
  { key: 'name', title: 'Назва' },
  { key: 'description', title: 'Опис' },
  { key: 'actions', title: 'Дії', sortable: false, align: 'end' },
]

const internalDepartmentHeaders: DataTableHeader[] = [
  { key: 'internalCode', title: 'Код' },
  { key: 'name', title: 'Назва' },
  { key: 'departmentType', title: 'Тип підрозділу' },
  { key: 'description', title: 'Опис' },
  { key: 'isActive', title: 'Статус', sortable: false },
  { key: 'actions', title: 'Дії', sortable: false, align: 'end' },
]

const internalStaffUnitHeaders: DataTableHeader[] = [
  { key: 'name', title: 'Повна назва' },
  { key: 'department', title: 'Підрозділ' },
  { key: 'position', title: 'Посада' },
  { key: 'staffUnitType', title: 'Тип штатної одиниці' },
  { key: 'assignedEmployee', title: 'Призначений' },
  { key: 'actions', title: 'Дії', sortable: false, align: 'end' },
]

const staffUnitAssignmentHeaders: DataTableHeader[] = [
  { key: 'employee', title: 'Співробітник' },
  { key: 'staffUnit', title: 'Штатна одиниця' },
  { key: 'appointmentType', title: 'Тип призначення' },
  { key: 'dateFrom', title: 'Дата з' },
  { key: 'dateTo', title: 'Дата по' },
  { key: 'actions', title: 'Дії', sortable: false, align: 'end' },
]

const registrationJournalListHeaders: DataTableHeader[] = [
  { key: 'code', title: 'Код' },
  { key: 'name', title: 'Назва' },
  { key: 'numberMask', title: 'Реєстраційна маска', sortable: false },
  { key: 'isActive', title: 'Статус', sortable: false },
  { key: 'actions', title: 'Дії', sortable: false, align: 'end' },
]

const numberReservationHeaders: DataTableHeader[] = [
  { key: 'registrationNumber', title: 'Номер', sortable: false },
  { key: 'journal', title: 'Журнал', sortable: false },
  { key: 'author', title: 'Зарезервовано за', sortable: false },
  { key: 'reservedBy', title: 'Ким зарезервовано', sortable: false },
  { key: 'reservedAt', title: 'Дата резервування', sortable: false },
  { key: 'status', title: 'Статус', sortable: false },
  { key: 'actions', title: '', sortable: false, align: 'end' },
]

const docTypeAccessListHeaders: DataTableHeader[] = [
  { key: 'entity', title: 'Адресат' },
  { key: 'actions', title: 'Дії', sortable: false, align: 'end' },
]

const delegationDocumentListHeaders: DataTableHeader[] = [
  { title: 'Назва документа', key: 'name', align: 'start' },
  { title: 'Системний номер', key: 'uuid', align: 'start' },
  { title: 'Клас', key: 'class', align: 'start' },
  { title: 'Дата', key: 'created_at', align: 'start' },
  { title: 'Статус', key: 'status', align: 'start' },
]

const searchResultHeaders: DataTableHeader[] = [
  {
    title: '№ документа',
    key: 'documentNumber',
    sortable: false,
    minWidth: '190px',
    maxWidth: '190px',
  },
  {
    title: 'Зміст',
    key: 'title',
    sortable: false,
    minWidth: '360px',
    maxWidth: '360px',
  },
  {
    title: 'Журнал реєстрації',
    key: 'registrationJournal',
    sortable: false,
    minWidth: '190px',
    maxWidth: '190px',
  },
  {
    title: 'Дата реєстрації',
    key: 'registrationDate',
    sortable: false,
    minWidth: '190px',
    maxWidth: '190px',
  },
  {
    title: 'Підрозділ',
    key: 'department',
    sortable: false,
    minWidth: '190px',
    maxWidth: '190px',
  },
  {
    title: 'Автор',
    key: 'author',
    sortable: false,
    minWidth: '190px',
    maxWidth: '190px',
  },
  {
    title: 'Дата створення',
    key: 'createdAt',
    sortable: false,
    minWidth: '160px',
    maxWidth: '160px',
  },
  { title: 'Статус', key: 'status', sortable: false, minWidth: '160px' },
]

export {
  documentListHeaders,
  incidentIssueTaskHeaders,
  incidentSettlementListHeaders,
  auditRecommendationTaskListHeaders,
  incidentListHeaders,
  taskHeaders,
  correspondenceListHeaders,
  correspondenceTaskHeaders,
  historyHeaders,
  orderTaskHeaders,
  protocolTaskHeaders,
  contractorFounderListHeaders,
  contractorBeneficialListHeaders,
  contractorQuedHeaders,
  contractorCollegialListHeaders,
  contractorDirectorListHeaders,
  companyStructureHeaders,
  familiarizationListHeaders,
  documentAgreementUsersHeaders,
  familiarizationUsersHeaders,
  documentAgreementLogsHeaders,
  orderListHeaders,
  protocolListHeaders,
  departmentListHeaders,
  departmentUserListHeaders,
  acknowledgmentAssignmentListHeaders,
  auditListHeaders,
  auditRecommendationListHeaders,
  contractorListHeaders,
  templateRoutingListHeaders,
  planAuditListHeaders,
  internalDepartmentListHeaders,
  roleListHeaders,
  fieldDefinitionListHeaders,
  docTypeFieldListHeaders,
  docTypeDefinitionListHeaders,
  docTypeDocumentListHeaders,
  orgDirectoryHeaders,
  internalDepartmentHeaders,
  internalStaffUnitHeaders,
  staffUnitAssignmentHeaders,
  registrationJournalListHeaders,
  numberReservationHeaders,
  docTypeAccessListHeaders,
  delegationDocumentListHeaders,
  searchResultHeaders,
}
